import { AccessibilitySettings } from './accessibility.service';

// Native document frames cannot inherit the application stylesheet.
export function readonlyDocumentStyles(settings: AccessibilitySettings): string {
  const rules: string[] = [];

  if (settings.fontSize !== 'normal') {
    const scale = settings.fontSize === 'large' ? 1.25 : 1.5;

    rules.push(
      'body { width: 100% !important; min-height: 0 !important; padding: 1rem !important; zoom: 1 !important; }',
      'body { font-size: ' + 14 * scale + 'pt !important; }',
      'body * { font-size: inherit !important; line-height: 1.5 !important; }',
      'h1 { font-size: 1.6em !important; } h2 { font-size: 1.4em !important; } h3 { font-size: 1.2em !important; }',
      'table, td, th { height: auto !important; }',
    );
  }

  if (settings.fontFamily !== 'default') {
    const family = settings.fontFamily === 'serif' ? 'Georgia, serif' : 'Arial, sans-serif';

    rules.push('body, body * { font-family: ' + family + ' !important; }');
  }

  if (settings.letterSpacing !== 'normal') {
    const spacing = settings.letterSpacing === 'wide' ? '0.06em' : '0.12em';

    rules.push('body, body * { letter-spacing: ' + spacing + ' !important; }');
  }

  if (settings.colorScheme !== 'default') {
    const background =
      settings.colorScheme === 'grayscale' ? '#fff' : settings.colorScheme === 'blue' ? '#063970' : '#000';
    const text = settings.colorScheme === 'grayscale' ? '#000' : '#fff';
    const link = settings.colorScheme === 'contrast' ? '#ffe55c' : text;

    rules.push(
      'html, body { background: ' + background + ' !important; color: ' + text + ' !important; }',
      'body * { background-color: transparent !important; color: ' +
        text +
        ' !important; border-color: ' +
        text +
        ' !important; }',
      'body a, body a * { color: ' + link + ' !important; }',
    );
  }

  if (!settings.images) rules.push('img { opacity: 0 !important; }');

  return rules.length ? '@media screen { ' + rules.join('\n') + ' }' : '';
}
